export const SUPPORTED_FILTERS_QUICKBOOKS_ONLINE = {
  ERROR_TYPES: 'error_types',
  INVOICE_NUMBER: 'invoice_number',
};

export const SORTABLE_ERROR_COLUMNS_QUICKBOOKS_ONLINE = {
  TIME: 'created_at',
};

export const DEFAULT_FILTERS_QUICKBOOKS_ONLINE = Object.freeze({
  [SUPPORTED_FILTERS_QUICKBOOKS_ONLINE.ERROR_TYPES]: [],
  [SUPPORTED_FILTERS_QUICKBOOKS_ONLINE.INVOICE_NUMBER]: undefined,
});

export const QUICKBOOKS_ONLINE_ERROR_FILTER_NAMESPACE = 'quickBooksOnlineErrorFilters';
export const QUICKBOOKS_ONLINE_ERROR_SORT_NAMESPACE = 'quickBooksOnlineErrorTableSort';
export const QUICKBOOKS_ONLINE_NAMESPACE = 'quickBooksOnline';
export const QUICKBOOKS_ONLINE_CONNECTION_STATUS_NAMESPACE = 'quickbooksOnlineConnectionStatus';
export const QUICKBOOKS_ONLINE_ACCOUNT_DETAILS_NAMESPACE = 'quickbooksOnlineAccountInfo';
export const QUICKBOOKS_ONLINE_LINKED_DATA_SUMMARY_NAMESPACE = 'quickbooksOnlineLinkedDataSummary';
export const QUICKBOOKS_ONLINE_IMPORT_FROM_DATE = 'quickbooksOnlineImportFromDate';

export const DEFAULT_INCOME_ACCOUNT_NAME = 'Sales of Product Income';
export const SUBTYPE_SALES_OF_PRODUCT_INCOME = 'SalesOfProductIncome';

export const PROCESS_STATUSES_QUICKBOOKS_ONLINE = {
  pendingStart: 'pending_start',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
};

export const PROCESS_KINDS_QUICKBOOKS_ONLINE = {
  import: 'import',
  rollback: 'rollback',
  unlink: 'unlink',
};

export const CONNECTION_STATUSES_QUICKBOOKS_ONLINE = {
  disconnected: 'disconnected_from_housecall',
  unverified: 'unverified',
  invalidated: 'invalidated_by_quickbooks',
  inactiveSubscription: 'inactive_quickbooks_subscription',
  active: 'active',
};

export const PROCESS_EXPANSIONS_QUICKBOOKS_ONLINE = {
  counts: 'counts',
  reports: 'reports',
};

export const DISCONNECT_REASONS_QUICKBOOKS_ONLINE = {
  wrongAccount: 'connected_wrong_account',
  incorrectImport: 'incorrect_import',
  testingIntegration: 'testing_integration',
  leavingHcp: 'leaving_hcp',
  dontLike: 'dont_like_integration',
  other: 'other',
};
